import { Helmet } from 'react-helmet-async';

const MetaTags = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  siteName = 'FilmųDB',
  locale = 'lt_LT',
  imageWidth = '1200',
  imageHeight = '630',
  keywords = ''
}) => {
  // Fallback values
  const defaultTitle = 'FilmųDB - Filmų ir TV serialų atradimo platforma';
  const defaultDescription = 'Filmų ir serialų įvertinimai iš IMDb, Rotten Tomatoes ir kitų šaltinių vienoje vietoje. Sužinok, kur žiūrėti Lietuvoje. 50K+ filmų, 20K+ serialų, 1M+ atsiliepimų.';
  const defaultImage = 'https://filmudb.lt/og-image.png';
  const defaultUrl = 'https://filmudb.lt';
  const defaultKeywords = 'filmai, televizijos serialai, kino duomenų bazė, filmų atsiliepimas, TV serialų atsiliepimas, populiarūs filmai, lietuvių filmų duomenų bazė';

  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalImage = image || defaultImage;
  const finalUrl = url || defaultUrl;
  const finalKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="title" content={finalTitle} />
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="author" content="FilmųDB" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={finalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content={imageWidth} />
      <meta property="og:image:height" content={imageHeight} />
      <meta property="og:image:alt" content={finalTitle} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalUrl} />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={finalImage} />
      <meta property="twitter:image:alt" content={finalTitle} />
    </Helmet>
  );
};

export default MetaTags; 